<div class="jumbotron center bg-white">
  <div class="text-center m-auto">
    <h1>{{ errorTitle }}</h1>
    <h3>{{ errorMessage }}</h3>
    <img class="d-block m-auto img-fluid" [src]="errorPic" alt="error-pic" />

    <button class="mat-main-button uppercase mt-4" (click)="goHome()" mat-flat-button color="primary">Take Me Home</button>
  </div>
</div>
